import React from "react";
import "./wmTextArea.css";

function WmTextarea({ name, placeholder, onChange, onKeyUp, maxLength, value,className }) {
  return (
    <textarea
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      onKeyUp={onKeyUp}
      value={value}
      className={`m_form_input border-bottom border-gray-300 wmTextAreaFocus ${className}`}
      maxLength={maxLength}
    ></textarea>
  );
}

export default WmTextarea;
